import { render, staticRenderFns } from "./TeachingPlanDetail.vue?vue&type=template&id=5816684a&scoped=true&"
import script from "./TeachingPlanDetail.vue?vue&type=script&lang=js&"
export * from "./TeachingPlanDetail.vue?vue&type=script&lang=js&"
import style0 from "./TeachingPlanDetail.vue?vue&type=style&index=0&id=5816684a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5816684a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VChip,VCol,VRow})
